import React, { useEffect, useMemo } from 'react'
import { useState } from 'react'
import Content from './Content'
import MyTask from './MyTask'
import { useUser } from '../../auth'
import { ReactComponent as UpcomingArrows } from '../../assets/svg/upcomingArrows.svg'
import LoginBG from '../../assets/images/AlkalmaLoginBackground.png'
import UpcomingContentModal from '../modals/UpcomingContentModal'
import { getNumberOfContentForReview, getUpcomingNum } from '../../server/server'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'
import ReviewContentModal from '../modals/ReviewContentModal'
import { usePageTitle } from '../../utils/util'

function Dashboard() {
    const { t, locale } = useTranslation()
    usePageTitle('AlkalmaUp - Dashboard')
    const { user, setUser } = useUser()
    const [showUpcomingContentModal, setShowUpcomingContentModal] = useState(false)
    const [showReviewContentModal, setShowReviewModal] = useState(false)
    const [numUpcomingContent, setNumUpcomingContent] = useState(3)
    const [contentForReview, setContentForReview] = useState(3)
    const [dashboardMode, setDashboardMode] = useState('Results')

    const [loadingNum, setLoadingNum] = useState(true)
    const [loadingContentReview, setLoadingContentReview] = useState(true)
    const [contentState, setContentState] = useState('')
    const [refresh, setRefresh] = useState('')
    const [refreshNum, setRefreshNum] = useState('')
    const closeModal = () => {
        setShowUpcomingContentModal(false)
    }
    const closeReviewContentModal = () => {
        setShowReviewModal(false)
    }

    const isAbleToDoReview = useMemo(() => user?.contentSettings?.studentContentReviewer || user?.contentSettings?.staffContentReviewer, [user])

    const openMyUpstrive = () => {
        setDashboardMode('MyUpstrive')
    }

    const loadUpcomingNum = async () => {
        const resp = await getUpcomingNum()
        if (resp?.status === 200) {
            setLoadingNum(false)
            setNumUpcomingContent(resp?.data)
        }
    }

    const loadNumberOfContentForReview = async () => {
        if (isAbleToDoReview) {
            const resp = await getNumberOfContentForReview()
            if (resp?.status === 200) {
                setLoadingContentReview(false)
                setContentForReview(resp?.data?.length)
            }
        }
    }

    useEffect(() => {
        loadUpcomingNum()
        loadNumberOfContentForReview()
    }, [refreshNum])

    return (
        <div className="flex justify-center bg-[#ECF6FB] h-full overflow-y-scroll px-2 pb-2">
            {/* <div className="absolute top-0 left-0 w-full h-full bg-repeat bg-contain bg-center" style={{ backgroundImage: `url(${LoginBG})` }}></div> */}
            <div className="dashboard-layout flex flex-row gap-[35px]  py-10 w-full  max-w-[1380px] mx-auto h-fit min-h-full">
                <div className="dashboard-left-side flex-1 xxs:max-w-[96%] xl:max-w-[865px] mx-auto ">
                    <Content refresh={refresh} setRefresh={setRefresh} setContentState={setContentState} />
                </div>
                <div className="xxs:hidden xl:block shadow-custom-soft rounded-[10px]">
                    <MyTask user={user} />
                </div>
            </div>

            <button
                className={`${
                    contentState === 'myTask' ? 'invisible' : ''
                } absolute bottom-6 right-6 font-bold pointer bg-aquaPulse rounded-3xl text-white py-[0.8rem] px-5 flex items-center z-10`}
                onClick={() => setShowUpcomingContentModal(true)}
                id="upcoming-content-modal-trigger"
            >
                <div className="relative flex items-center  ">
                    <UpcomingArrows />
                    <span className="ml-3">{t('upcomingContent')} </span>
                    <div className="w-[30px] h-[30px] rounded-full bg-deepOcean border text-white bottom-5 -right-5 border-white absolute flex items-center justify-center">
                        {loadingNum ? <Loading primaryColor="#5E639B" secondaryColor="#5E639B" size={18} stroke={8} /> : numUpcomingContent}
                    </div>
                </div>
            </button>
            {isAbleToDoReview && (
                <button
                    className={`${
                        contentState === 'myTask' ? 'invisible' : ''
                    } absolute bottom-6 right-60 font-bold pointer bg-aquaPulse rounded-3xl text-white py-[0.8rem] px-5 flex items-center z-10`}
                    onClick={() => setShowReviewModal(true)}
                    id="review-content-modal-trigger"
                >
                    <div className="relative flex items-center  ">
                        <UpcomingArrows />
                        <span className="ml-3">{t('Review content')} </span>
                        <div className="w-[30px] h-[30px] rounded-full bg-deepOcean border text-white bottom-5 -right-5 border-white absolute flex items-center justify-center">
                            {loadingContentReview ? <Loading primaryColor="#5E639B" secondaryColor="#5E639B" size={18} stroke={8} /> : contentForReview}
                        </div>
                    </div>
                </button>
            )}

            <UpcomingContentModal showRun={showUpcomingContentModal} closeRun={closeModal} num={numUpcomingContent} setRefreshNum={setRefreshNum} />
            <ReviewContentModal showRun={showReviewContentModal} closeRun={closeReviewContentModal} num={contentForReview} setRefreshNum={setRefreshNum} />
        </div>
    )
}

export default Dashboard
